import P2Regular from 'components/typography/P2Regular';
import { FaultRow } from 'components/tables/data/fault/types';

/**
 * Column for the device type name.
 */
export default function DeviceTypeNameColumn({ data: { deviceType } }: { data: FaultRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {deviceType.deviceTypeName}
    </P2Regular>
  );
}
